import {
  ExpensesEntitiesExpensableStatusEnum,
  GetExpensesCountDocument,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

interface Props {
  status: ExpensesEntitiesExpensableStatusEnum
  pendingApproval?: string
}

const useGetExpensesCount = ({ status, pendingApproval }: Props) => {
  const { employee } = useCurrentSession()
  const isDraft = status === 'draft'

  const { loading, data } = useQuery(GetExpensesCountDocument, {
    variables: {
      filter: {
        status: { eq: status },
        pendingApproval: pendingApproval ? { eq: pendingApproval } : undefined,
      },
      includeManualDrafts: isDraft,
      employeeIds: isDraft ? [employee!.id] : null,
    },
  })

  return {
    loading,
    expenseCount: data?.expenses.expensablesConnection.totalCount,
  }
}

export default useGetExpensesCount
